// extracted by mini-css-extract-plugin
module.exports = {"container":"TopBar_container__DERLr","sejfaLogo":"TopBar_sejfaLogo__lr6g6","buttonsContainer":"TopBar_buttonsContainer__DzBHN"};